/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap as cssMapCompiled, jsx } from '@compiled/react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';
import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';

import { messages } from '../i18n';
import AccessLockSVG from '../icons/AccessLockSVG';

import { AccessLockSVGWrapper, ActionButtonWrapper } from './styled';

// TODO: After ptc-people-teams-migrate-styled-components FF cleanup:
// - Remove wrapper pattern (fg() conditionals) and use css={} directly
// - Remove Styled imports and styled.ts references
const compiledStyles = cssMapCompiled({
	accessLockSVGWrapper: {
		marginBottom: token('space.600'),
	},
	actionButtonWrapper: {
		marginTop: token('space.100'),
	},
});

const NoAccessErrorState = ({ onAction }: { onAction: () => void }): React.JSX.Element => {
	const intl = useIntl();

	// TODO: Remove wrappers after ptc-people-teams-migrate-styled-components FF cleanup
	const ActionButtonContainer = fg('ptc-people-teams-migrate-styled-components')
		? (props: React.HTMLAttributes<HTMLDivElement>) => (
				<div css={compiledStyles.actionButtonWrapper} {...props} />
			)
		: ActionButtonWrapper;

	const AccessLockImageContainer = fg('ptc-people-teams-migrate-styled-components')
		? (props: React.HTMLAttributes<HTMLDivElement>) => (
				<div css={compiledStyles.accessLockSVGWrapper} {...props} />
			)
		: AccessLockSVGWrapper;

	const action = (
		<ActionButtonContainer>
			<Button onClick={onAction} appearance="primary">
				<FormattedMessage {...messages.noAccessErrorStateActionLabel} />
			</Button>
		</ActionButtonContainer>
	);

	return (
		<EmptyState
			header={intl.formatMessage(messages.noAccessErrorStateTitle)}
			description={intl.formatMessage(messages.noAccessErrorStateMessage)}
			primaryAction={action}
			renderImage={() => (
				<AccessLockImageContainer>
					<AccessLockSVG />
				</AccessLockImageContainer>
			)}
		/>
	);
};

export default NoAccessErrorState;
